import React, { useEffect, useState } from 'react'
import { CheckboxField } from 'components/Shared/CheckboxField'
import * as Yup from 'yup'
import { FormikForm } from 'components/Shared/FormikForm'
import { Form } from 'formik'
import { fetchNotificationsSettings, updateNotificationsSettings } from 'services'
import { useErrorHandling } from 'context/errorHandling'
import { Loader } from 'components/Shared/Loader'

export function UserNotificationsSettings ({ user }) {
  const [userSettings, setUserSettings] = useState()
  const { handleError } = useErrorHandling()
  const validationSchema = Yup.object().shape({
                                                sendOnNewAttachmentEmailNotification: Yup.bool(),
                                                sendOnOrderWaitingOnApproveEmailNotification: Yup.bool(),
                                                sendOnOrderActionEmailNotification: Yup.bool()
                                              })

  useEffect(() => {
    fetchNotificationsSettings().then(settings => setUserSettings(settings)).catch(handleError)
  }, [user, handleError])

  const handleSubmit = (values) => {
    updateNotificationsSettings(values).catch(handleError)
  }

  return userSettings ? <FormikForm
    initialValues={userSettings}
    preventNavigation={false}
    validationSchema={validationSchema}
    onSubmit={handleSubmit}>
    {({ handleSubmit }) => <Form className={'col'}>
      <div className={'row'}>
        <CheckboxField name={'sendOnNewAttachmentEmailNotification'} label={'user.emailNotificationsSettings.newAttachment'} onChange={() => handleSubmit()}/>
      </div>
      <div className={'row'}>
        <CheckboxField name={'sendOnOrderWaitingOnApproveEmailNotification'} label={'user.emailNotificationsSettings.orderWaitingForApprove'} onChange={() => handleSubmit()}/>
      </div>
      <div className={'row'}>
        <CheckboxField name={'sendOnOrderActionEmailNotification'} label={'user.emailNotificationsSettings.orderAction'} onChange={() => handleSubmit()}/>
      </div>
    </Form>}
  </FormikForm> : <Loader/>
}
